import { type FC } from 'react';

import { Skeleton } from '@vakantiesnl/components/src/atoms/Skeleton/Skeleton';

import filterListSkeleton from './skeletons/filter-list.svg';

type Props = {
	number?: number;
};

export const FilterListSkeleton: FC<Props> = ({ number = 3 }) => {
	const numFilters = Array.from(Array(number).keys());
	return (
		<>
			{numFilters.map((key) => (
				<Skeleton svg={filterListSkeleton} key={key} />
			))}
		</>
	);
};
